/**
 * This is a way for all parts of the application to broadcast and listen for global events.
 * (Nothing to do with DigiTickets Events/Sessions)
 *
 * It just uses Angular's $rootScope currently, but the purpose of this is to write new code that is not coupled
 * to Angular. We can change the implementation here in future without having to update lots of code.
 * Only broadcasting is implemented, not listening, because the latter needs some thought.
 */
class EventBus {
    /**
     * @param $rootScope
     */
    constructor($rootScope) {
        /**
         * @private
         */
        this.$rootScope = $rootScope;
    }

    /**
     * @type {string} eventName
     * @type {object} [data]
     */
    broadcast(eventName, data) {
        console.debug('[EventBus] Broadcasting', eventName, data);
        this.$rootScope.$broadcast(eventName, data);
    }

    // ⚠ This is not implemented because it is not as simple as it looks. ⚠
    //
    // You might see this and think an easy way is to just store the handler function in an object and call that
    // function for each broadcast, but that would cause a memory leak as there is nothing to remove the handlers.
    // Each time you visit a page that listens for an event it would add another one to the list of handlers.
    // /**
    //  * @param {string} eventName
    //  * @param {Function} handler
    //  */
    // on(eventName, handler) {
    //
    // }
}

module.exports = EventBus;
